/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addMemberToTeamPlanner } from '../fn/team-planners/add-member-to-team-planner';
import { AddMemberToTeamPlanner$Params } from '../fn/team-planners/add-member-to-team-planner';
import { createTeamPlanner } from '../fn/team-planners/create-team-planner';
import { CreateTeamPlanner$Params } from '../fn/team-planners/create-team-planner';
import { deleteTeamPlanner } from '../fn/team-planners/delete-team-planner';
import { DeleteTeamPlanner$Params } from '../fn/team-planners/delete-team-planner';
import { getTeamPlanner } from '../fn/team-planners/get-team-planner';
import { GetTeamPlanner$Params } from '../fn/team-planners/get-team-planner';
import { listTeamPlannerGroupsAddable } from '../fn/team-planners/list-team-planner-groups-addable';
import { ListTeamPlannerGroupsAddable$Params } from '../fn/team-planners/list-team-planner-groups-addable';
import { listTeamPlannerGroupsAdded } from '../fn/team-planners/list-team-planner-groups-added';
import { ListTeamPlannerGroupsAdded$Params } from '../fn/team-planners/list-team-planner-groups-added';
import { listTeamPlanners } from '../fn/team-planners/list-team-planners';
import { ListTeamPlanners$Params } from '../fn/team-planners/list-team-planners';
import { listTeamPlannerUsers } from '../fn/team-planners/list-team-planner-users';
import { ListTeamPlannerUsers$Params } from '../fn/team-planners/list-team-planner-users';
import { listTeamPlannerUsersAddable } from '../fn/team-planners/list-team-planner-users-addable';
import { ListTeamPlannerUsersAddable$Params } from '../fn/team-planners/list-team-planner-users-addable';
import { listTeamPlannerUsersAdded } from '../fn/team-planners/list-team-planner-users-added';
import { ListTeamPlannerUsersAdded$Params } from '../fn/team-planners/list-team-planner-users-added';
import { removeMemberFromTeamPlanner } from '../fn/team-planners/remove-member-from-team-planner';
import { RemoveMemberFromTeamPlanner$Params } from '../fn/team-planners/remove-member-from-team-planner';
import { TeamPlannerDto } from '../models/team-planner-dto';
import { TeamPlannerDtoPage } from '../models/team-planner-dto-page';
import { TeamPlannerGroupDtoPage } from '../models/team-planner-group-dto-page';
import { TeamPlannerUserDtoPage } from '../models/team-planner-user-dto-page';
import { updateTeamPlanner } from '../fn/team-planners/update-team-planner';
import { UpdateTeamPlanner$Params } from '../fn/team-planners/update-team-planner';

@Injectable({ providedIn: 'root' })
export class TeamPlannersApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listTeamPlanners()` */
  static readonly ListTeamPlannersPath = '/v0/teamPlanners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTeamPlanners()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlanners$Response(params?: ListTeamPlanners$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDtoPage>> {
    return listTeamPlanners(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTeamPlanners$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlanners(params?: ListTeamPlanners$Params, context?: HttpContext): Observable<TeamPlannerDtoPage> {
    return this.listTeamPlanners$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerDtoPage>): TeamPlannerDtoPage => r.body)
    );
  }

  /** Path part for operation `getTeamPlanner()` */
  static readonly GetTeamPlannerPath = '/v0/teamPlanners/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTeamPlanner()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTeamPlanner$Response(params: GetTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDto>> {
    return getTeamPlanner(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTeamPlanner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTeamPlanner(params: GetTeamPlanner$Params, context?: HttpContext): Observable<TeamPlannerDto> {
    return this.getTeamPlanner$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerDto>): TeamPlannerDto => r.body)
    );
  }

  /** Path part for operation `updateTeamPlanner()` */
  static readonly UpdateTeamPlannerPath = '/v0/teamPlanners/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTeamPlanner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTeamPlanner$Response(params: UpdateTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDto>> {
    return updateTeamPlanner(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTeamPlanner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTeamPlanner(params: UpdateTeamPlanner$Params, context?: HttpContext): Observable<TeamPlannerDto> {
    return this.updateTeamPlanner$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerDto>): TeamPlannerDto => r.body)
    );
  }

  /** Path part for operation `createTeamPlanner()` */
  static readonly CreateTeamPlannerPath = '/v0/teamPlanners/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTeamPlanner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTeamPlanner$Response(params: CreateTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDto>> {
    return createTeamPlanner(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTeamPlanner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTeamPlanner(params: CreateTeamPlanner$Params, context?: HttpContext): Observable<TeamPlannerDto> {
    return this.createTeamPlanner$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerDto>): TeamPlannerDto => r.body)
    );
  }

  /** Path part for operation `deleteTeamPlanner()` */
  static readonly DeleteTeamPlannerPath = '/v0/teamPlanners/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTeamPlanner()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTeamPlanner$Response(params: DeleteTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTeamPlanner(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTeamPlanner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTeamPlanner(params: DeleteTeamPlanner$Params, context?: HttpContext): Observable<void> {
    return this.deleteTeamPlanner$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listTeamPlannerUsers()` */
  static readonly ListTeamPlannerUsersPath = '/v0/teamPlanners/{id}/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTeamPlannerUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerUsers$Response(params: ListTeamPlannerUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerUserDtoPage>> {
    return listTeamPlannerUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTeamPlannerUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerUsers(params: ListTeamPlannerUsers$Params, context?: HttpContext): Observable<TeamPlannerUserDtoPage> {
    return this.listTeamPlannerUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerUserDtoPage>): TeamPlannerUserDtoPage => r.body)
    );
  }

  /** Path part for operation `listTeamPlannerUsersAddable()` */
  static readonly ListTeamPlannerUsersAddablePath = '/v0/teamPlanners/{id}/users-addable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTeamPlannerUsersAddable()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerUsersAddable$Response(params: ListTeamPlannerUsersAddable$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerUserDtoPage>> {
    return listTeamPlannerUsersAddable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTeamPlannerUsersAddable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerUsersAddable(params: ListTeamPlannerUsersAddable$Params, context?: HttpContext): Observable<TeamPlannerUserDtoPage> {
    return this.listTeamPlannerUsersAddable$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerUserDtoPage>): TeamPlannerUserDtoPage => r.body)
    );
  }

  /** Path part for operation `listTeamPlannerUsersAdded()` */
  static readonly ListTeamPlannerUsersAddedPath = '/v0/teamPlanners/{id}/users-added';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTeamPlannerUsersAdded()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerUsersAdded$Response(params: ListTeamPlannerUsersAdded$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerUserDtoPage>> {
    return listTeamPlannerUsersAdded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTeamPlannerUsersAdded$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerUsersAdded(params: ListTeamPlannerUsersAdded$Params, context?: HttpContext): Observable<TeamPlannerUserDtoPage> {
    return this.listTeamPlannerUsersAdded$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerUserDtoPage>): TeamPlannerUserDtoPage => r.body)
    );
  }

  /** Path part for operation `listTeamPlannerGroupsAddable()` */
  static readonly ListTeamPlannerGroupsAddablePath = '/v0/teamPlanners/{id}/groups-addable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTeamPlannerGroupsAddable()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerGroupsAddable$Response(params: ListTeamPlannerGroupsAddable$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerGroupDtoPage>> {
    return listTeamPlannerGroupsAddable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTeamPlannerGroupsAddable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerGroupsAddable(params: ListTeamPlannerGroupsAddable$Params, context?: HttpContext): Observable<TeamPlannerGroupDtoPage> {
    return this.listTeamPlannerGroupsAddable$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerGroupDtoPage>): TeamPlannerGroupDtoPage => r.body)
    );
  }

  /** Path part for operation `listTeamPlannerGroupsAdded()` */
  static readonly ListTeamPlannerGroupsAddedPath = '/v0/teamPlanners/{id}/groups-added';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTeamPlannerGroupsAdded()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerGroupsAdded$Response(params: ListTeamPlannerGroupsAdded$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerGroupDtoPage>> {
    return listTeamPlannerGroupsAdded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTeamPlannerGroupsAdded$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTeamPlannerGroupsAdded(params: ListTeamPlannerGroupsAdded$Params, context?: HttpContext): Observable<TeamPlannerGroupDtoPage> {
    return this.listTeamPlannerGroupsAdded$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamPlannerGroupDtoPage>): TeamPlannerGroupDtoPage => r.body)
    );
  }

  /** Path part for operation `addMemberToTeamPlanner()` */
  static readonly AddMemberToTeamPlannerPath = '/v0/teamPlanners/{id}/add-member';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addMemberToTeamPlanner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMemberToTeamPlanner$Response(params: AddMemberToTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addMemberToTeamPlanner(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addMemberToTeamPlanner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMemberToTeamPlanner(params: AddMemberToTeamPlanner$Params, context?: HttpContext): Observable<void> {
    return this.addMemberToTeamPlanner$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeMemberFromTeamPlanner()` */
  static readonly RemoveMemberFromTeamPlannerPath = '/v0/teamPlanners/{id}/remove-member';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeMemberFromTeamPlanner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeMemberFromTeamPlanner$Response(params: RemoveMemberFromTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeMemberFromTeamPlanner(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeMemberFromTeamPlanner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeMemberFromTeamPlanner(params: RemoveMemberFromTeamPlanner$Params, context?: HttpContext): Observable<void> {
    return this.removeMemberFromTeamPlanner$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
